import classNames from 'classnames';

export type LabelProps = {
    children: React.ReactNode;
    class?: string;
    className?: string;
    style?: React.CSSProperties;
    bold?: boolean;
    color?:
        | 'text-white'
        | 'text-dark-blue'
        | 'text-dark-red'
        | 'text-grey-900'
        | 'text-grey-textfield-placeholder'
        | 'text-vibrant-blue'
        | 'text-falck-red'
        | 'text-success'
        | 'text-secondary-error';
};
type Props = LabelProps & {
    variant:
        | 'text-body'
        | 'text-body-headline'
        | 'text-body-sm'
        | 'text-breadcrumbs-active'
        | 'text-lg'
        | 'text-mobile-display-4'
        | 'text-display-3'
        | 'text-mobile-display-2'
        | 'text-mobile-display-1'
        | 'text-headline-cursive'
        | 'text-blue-cursive';
};
export function Label({
    bold = false,
    variant,
    color,
    className,
    class: class_,
    ...props
}: Props) {
    return (
        <div
            {...props}
            className={classNames(class_, className, variant, color, {
                'font-bold': bold,
            })}
        />
    );
}
